import { CalendarDaysIcon } from 'assets/icons';
import Button from 'components/button';

/**
 * « Prochaine action », on the orange tint of the prototype: what comes next
 * with a company (its title and when), and the two buttons that act on it
 * (`primary`, `secondary`: { label, onClick }), side by side.
 */
const NextActionCard = ({ label, title, detail, primary, secondary }) => (
  <section className="rounded-xl bg-yellow-50 p-4">
    <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-white text-gray-900">
      <CalendarDaysIcon wh={20} color="currentColor" />
    </span>
    <p className="mt-3 text-xs font-medium uppercase text-gray-700">{label}</p>
    <p className="mt-1 ft-b font-semibold text-gray-900">{title}</p>
    {detail && <p className="text-sm text-gray-700">{detail}</p>}
    <div className="mt-4 flex gap-3">
      {primary && (
        <Button color="PRIMARY" size="SM" className="flex-1 whitespace-nowrap !px-3" onClick={primary.onClick}>
          {primary.label}
        </Button>
      )}
      {secondary && (
        <Button color="SECONDARY" size="SM" className="flex-1 whitespace-nowrap !px-3" onClick={secondary.onClick}>
          {secondary.label}
        </Button>
      )}
    </div>
  </section>
);

export default NextActionCard;
